import React from 'react'

const perks = [
  { icon: '📦', label: 'Early Access', sub: 'First to know new arrivals' },
  { icon: '🎁', label: 'Member Deals', sub: 'Extra 10% off for subscribers' },
  { icon: '🚫', label: 'No Spam', sub: 'Unsubscribe anytime' },
];

const NewsLetter = () => {
  return (
    <section className='relative py-24 px-[8%] overflow-hidden border-t border-white/[0.05]'>
      {/* Ambient orbs */}
      <div className="absolute w-[600px] h-[600px] -top-48 -left-32 rounded-full blur-[100px] opacity-30 pointer-events-none animate-nl-pulse" style={{ background: 'radial-gradient(circle, rgba(0,212,255,0.18) 0%, transparent 70%)' }} />
      <div className="absolute w-[500px] h-[500px] -bottom-40 -right-24 rounded-full blur-[100px] opacity-30 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(124,58,237,0.18) 0%, transparent 70%)', animation: 'nl-pulse 10s ease-in-out infinite 5s' }} />

      <div className="relative z-10 max-w-[900px] mx-auto">
        <div
          className="rounded-[32px] overflow-hidden p-[60px_50px] max-[700px]:p-[48px_28px]"
          style={{ background: 'linear-gradient(135deg, #0d1a2d 0%, #0a1020 70%, #0d1526 100%)', border: '1px solid rgba(0,212,255,0.15)', boxShadow: '0 30px 80px rgba(0,0,0,0.5), inset 0 1px 0 rgba(0,212,255,0.1)' }}
        >
          {/* Top label */}
          <div className="text-center mb-8">
            <span className="inline-block bg-[rgba(0,212,255,0.1)] text-[#00d4ff] border border-[rgba(0,212,255,0.25)] px-4 py-[5px] rounded-full text-xs font-bold tracking-[2px] uppercase mb-5">📧 Stay In The Loop</span>
            <h2 className="text-[46px] font-black text-white leading-[1.1] -tracking-[1.5px] mb-4 max-[700px]:text-[32px]">
              Get <span className="shimmer-text">Exclusive Offers</span>
              <br/>in Your Inbox
            </h2>
            <p className="text-[#6b7a8d] text-base leading-[1.7] max-w-[480px] mx-auto">
              Join 50,000+ tech enthusiasts. Weekly deals, new arrivals &amp; reviews. No spam, ever.
            </p>
          </div>

          {/* Perks row */}
          <div className="flex justify-center gap-6 mb-8 flex-wrap">
            {perks.map(p => (
              <div key={p.label} className="flex items-center gap-2.5">
                <span className="text-xl">{p.icon}</span>
                <div>
                  <p className="text-white text-xs font-bold leading-none mb-0.5">{p.label}</p>
                  <p className="text-[#4a5568] text-[10px]">{p.sub}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Input row */}
          <div className="flex gap-3 max-w-[560px] mx-auto max-[600px]:flex-col">
            <div className="flex-1 flex items-center gap-3 rounded-2xl px-5 h-[56px] transition-all duration-200 focus-within:shadow-[0_0_0_2px_rgba(0,212,255,0.4)]" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4a5568" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              <input
                type="email"
                placeholder="your@email.com"
                className="flex-1 bg-transparent border-none outline-none text-[#e2e8f0] text-[15px] font-[inherit] placeholder:text-[#3d4f66]"
              />
            </div>
            <button
              className="h-[56px] px-8 rounded-2xl border-none text-[#060c18] text-[15px] font-extrabold cursor-pointer font-[inherit] whitespace-nowrap transition-all duration-200 hover:-translate-y-0.5 max-[600px]:w-full"
              style={{ background: 'linear-gradient(135deg, #00d4ff 0%, #0095c8 100%)', boxShadow: '0 8px 30px rgba(0,212,255,0.35)' }}
            >
              Subscribe Free →
            </button>
          </div>

          <p className="text-center text-[#3d4f66] text-xs mt-5">✓ Free forever &nbsp;·&nbsp; ✓ Cancel anytime &nbsp;·&nbsp; ✓ No credit card required</p>
        </div>
      </div>
    </section>
  )
}

export default NewsLetter
